import { Component, OnInit, OnChanges, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { SiFiltersService } from '../../../filter/si-filters.service';
import { AppService } from '../../../app.service';
import { DatePipe } from '@angular/common';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';
import { IfStmt } from '@angular/compiler';
import { SiDataService } from 'src/app/services/si-data.service';
import { SiTimezoneServiceService } from '../../si-timezone/si-timezone-service.service';
declare let $;
declare let d3;
declare let SiDataViz;
@Component({
  selector: 'si-tab-header',
  templateUrl: './tab-header.component.html',
  styleUrls: ['./tab-header.component.scss'],
  providers: [DatePipe]
})
export class TabHeaderComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() tabName: string;
  @Input() selectedTabName?: string;
  @Input() dayFilterObj: Array<object>;
  @Input() dayFilterValues: Array<object>;
  @Input() maxMinDate: Array<object>;
  @Input() dateRange: Array<object>;
  @Input() isDayFilterSelected: boolean;
  @Input() defaultDaysSelection: number;
  @Input() defaultGroupBySelection: object;
  @Input() isDateUpdatedByTabHeader: boolean;
  @Input() isResetAll: boolean;
  @Input() filterType: string;
  @Input() overlayScore?: string;
  @Input() description?: object;
  @Input() isThresholdVisible?: boolean;
  @Input() isTimerVisible?: boolean;
  @Input() isOCNTypeDropdownVisible?: boolean;
  @Input() ocnTypes?: Array<Object>;
  @Input() defaultOCNType?: Array<object>;
  @Input() thresholdConfig?: Array<object>;
  @Input() isBoundTypeVisible?: boolean;
  @Input() defaultBoundType?: string;
  @Input() showGroupByObj?: boolean;
  @Input() isChangedGroupByParam?: boolean;
  @Input() boundTypeDateConfig?: object;
  @Input() isVerstatToggleVisible?: boolean;
  @Input() verstatCustomLabel?: string = "Verstat";

  @Output() dateRangeSelected = new EventEmitter<any>();
  @Output() verstatToggleSelected = new EventEmitter();
  @Output() dateRangeToggleSelected = new EventEmitter();
  @Output() onBoundTypeSelected = new EventEmitter();

  // @ViewChild('slider') slider;
  // @ViewChild("slider", { static: true }) slider: any;
  @ViewChild('slider', { static: false }) slider;
  // @ViewChild('password', { static: true }) static: ElementRef<HTMLDivElement>;

  startDateHeading: Date;
  endDateHeading: Date;
  calculatedDateRange: object;
  filter: string;
  title: string;
  activeCustomer: string;
  // tslint:disable:radix
  threshold: number = parseInt(localStorage.getItem('threshold'));
  selectedFilterObj: object = {};
  thresholdFilterObj: object = {};
  dateFilterObj: object = {};
  ocnTypeFilterObj: object = {};
  isTerminationActive: boolean;
  isOriginationActive: boolean;
  activeBoundType: string;
  terminationFilterObj: object = {};
  originationFilterObj: object = {};
  thresholdPopover;
  groupByParam: object;
  selectedOCNType: any = 'tn_owner_ocn';
  selectedOCNTypeLabel: any = 'OCN';
  isRefreshTime: boolean = false;
  abbr: any;
  updatedTimeZone: any;
  preObj: any;
  rawRefreshTimeResponse: any;
  userNavigate: boolean = true;
  timerInterval: any;
  lastDataRefresh: any;
  localTime: any;
  display: any;
  timeOut: any;
  refreshDate: any;
  refreshInterval: number = 3600000;
  isAutoRefreshDisabled: boolean = false;
  isFilterExpanded: boolean = false;
  firstColumnWidth: string = '';
  secondColumnWidth: string = '';
  selectedDays: number;
  selectedCVTView: string = 'Robocall';

  // selectedOCNTypeLabel: any = 'TN Owner OCN';
  constructor(
    private el: ElementRef,
    private siFiltersService: SiFiltersService,
    private appService: AppService,
    private datePipe: DatePipe,
    private siAuthenticationService: SiAuthenticationService,
    private siDataService: SiDataService,
    private siTimeZoneService: SiTimezoneServiceService
  ) { }

   ngOnInit() {
     this.filter = this.filterType;
     this.activeCustomer = this.getActiveCustomerAndFormat();
     this.activeBoundType = this.defaultBoundType ? this.defaultBoundType : 'Terminating';
     this.isTerminationActive = this.activeBoundType === 'Terminating' ? true : false;
     this.isOriginationActive = this.activeBoundType === 'Originating' ? true : false;
     this.groupByParam = this.defaultGroupBySelection;
     if (this.defaultOCNType) {
       this.selectedOCNType = this.defaultOCNType;
       // this.selectedOCNTypeLabel = this.defaultOCNType['ocnType'] ? this.defaultOCNType['ocnType'] : 'TN Owner OCN';
       this.selectedOCNTypeLabel = 'OCN';
     }

     // Initialize preObj with default values
     this.preObj = {
       updatedTimeZone: null,
       abbr: null,
       auto_refresh: false
     };

     this.siTimeZoneService.prefSubject.subscribe(
       (auto_refresh_value) => {
         this.isAutoRefreshDisabled = auto_refresh_value;
       }
     );

     if (this.userNavigate) {
       const navigatePreferences = this.siDataService.getPreferences();
       if (navigatePreferences) {
         this.preObj = {
           updatedTimeZone: navigatePreferences.timezone,
           abbr: navigatePreferences.abbr,
           auto_refresh: navigatePreferences.auto_refresh
         };
         if (this.rawRefreshTimeResponse) {
           this.setLastDataRefresh(this.rawRefreshTimeResponse, this.preObj);
         }
       }
     }
     this.setColumnWidth();
     this.appService.filterExpanded.subscribe((value) => {
       this.isFilterExpanded = value;
       this.setColumnWidth();
     });

     // Run every time prefrences update
     this.siDataService.listen().subscribe((m: any) => {
       this.isRefreshTime = false;
       this.abbr = m.abbr;
       this.updatedTimeZone = m.timezone;
       this.preObj = { updatedTimeZone: this.updatedTimeZone, abbr: this.abbr, auto_refresh: m.auto_refresh };
       if (!m.auto_refresh || !this.isTimerVisible) {
         clearInterval(this.timerInterval);
         clearTimeout(this.timeOut);
         this.display = '';
       }
       if (this.rawRefreshTimeResponse && m.auto_refresh) {
         this.setLastDataRefresh(this.rawRefreshTimeResponse, this.preObj);
       }
       this.userNavigate = false;
     });

     this.getRefreshTime();
   }

  ngAfterViewInit() {
    if (this.slider) {
      this.thresholdPopover = $('<div class="popup"></div>');
      $(this.slider.el.nativeElement.children[0]).append(this.thresholdPopover);
      this.thresholdPopover[0].textContent = this.shortenLargeNumber(this.threshold, 1);
      this.setThresholdPopover(this.threshold);
    }
  }

  ngOnChanges(changes) {
    let maxMin;
    if (changes['tabName'] && !changes['tabName']['firstChange'] &&
      changes['tabName']['currentValue'] !== changes['tabName']['previousValue']) {
      return;
    }
    if (this.dateRange && this.isDayFilterSelected && !this.isChangedGroupByParam && this.isDateUpdatedByTabHeader && !this.isResetAll) {
      this.selectDateRange(this.defaultDaysSelection, this.maxMinDate);
    }
    if (!this.isDayFilterSelected && this.dateRange) {
      this.sortDatesConfigureHeading(this.dateRange);
      this.dayFilterValues = this.dayFilterValues.map(obj => Object.assign({}, obj));
      this.dayFilterValues.forEach((obj) => { obj['isSelected'] = false; });

    }

    if (this.isChangedGroupByParam && changes['isChangedGroupByParam'] &&
      changes['isChangedGroupByParam']['currentValue'] !== changes['isChangedGroupByParam']['previousValue'] &&
      this.maxMinDate && this.isDayFilterSelected && !this.isResetAll) {
      const selectedValue = this.dayFilterObj.filter((obj) => obj['key'] === this.isChangedGroupByParam);
      this.selectgroupByParam(selectedValue, this.maxMinDate, selectedValue[0]['value'][0]['value']);
    }

    if (this.isResetAll) {
      maxMin = this.siFiltersService.getDefaultMaxMinDate();
      this.activeBoundType = this.defaultBoundType ? this.defaultBoundType : 'Terminating';
      this.isTerminationActive = this.activeBoundType === 'Terminating' ? true : false;
      this.isOriginationActive = this.activeBoundType === 'Originating' ? true : false;
      if (this.defaultOCNType) {
        this.selectedOCNType = this.defaultOCNType;
        this.selectedOCNTypeLabel = 'OCN';
        // this.selectedOCNTypeLabel = this.defaultOCNType['ocnType'] ? this.defaultOCNType['ocnType'] : 'TN Owner OCN';
      }
      // this.selectedCVTView = 'Robocall';
      this.setDefaultTabHeader();
      this.isResetAll = false;
    }
    if (this.filterType) {
      this.filter = this.filterType;
    }


  }

  setDefaultTabHeader() {
    this.dayFilterObj = this.dayFilterObj.map(day => Object.assign({}, day));
    this.dayFilterObj.forEach((day) => {
      if (day['value'][0]['value'] === this.defaultDaysSelection) {
        day['isValueSelected'] = true;
        this.dayFilterValues = day['value'];
        this.groupByParam = day;
      } else {
        day['isValueSelected'] = false;
      }
    });
    this.dayFilterValues = this.dayFilterValues.map(obj => Object.assign({}, obj));
    this.dayFilterValues.forEach((obj) => {
      if (obj['value'] === this.defaultDaysSelection) {
        obj['isSelected'] = true;
      } else {
        obj['isSelected'] = false;
      }
    });
    if (this.boundTypeDateConfig && this.boundTypeDateConfig['isOriginatingDate']) {
      this.siFiltersService.setDefaultMaxMinDate(this.boundTypeDateConfig['maxMinDate']);
      this.maxMinDate = this.boundTypeDateConfig['maxMinDate'];
      this.dateRange = this.boundTypeDateConfig['dateRange'];
    }
    this.selectDateRange(this.defaultDaysSelection, this.maxMinDate);
  }

  onThresholdChange(event) {
    this.setThresholdPopover(event.value);
    this.thresholdPopover[0].textContent = this.shortenLargeNumber(event.value, 1);
  }

  setThresholdPopover(value) {
    let calculatePosition, valuePercent;
    // parseStyle = parseFloat(this.slider.el.nativeElement.children[0].children[1].style.left);
    // if (parseStyle > 96) {
    //   this.thresholdPopover[0].style.left = '' + (96) +'%';
    // } else {
    //   this.thresholdPopover[0].style.left = '' + (parseStyle) +'%';
    // }
    // this.thresholdPopover[0].style.left = (parseStyle) +'%';
    valuePercent = (value / this.thresholdConfig['max']) * 100;
    if (value < this.thresholdConfig['max'] - 10000) {
      calculatePosition = (((value - this.thresholdConfig['min']) / this.thresholdConfig['max']) * 100) - 1;
    } else if (value > this.thresholdConfig['max'] - 6000 && value < this.thresholdConfig['max'] - 1001) {
      calculatePosition = (((value - this.thresholdConfig['min']) / this.thresholdConfig['max']) * 100) + 2;
    } else if (valuePercent > 95) {
      calculatePosition = 96;
    } else {
      calculatePosition = (((value - this.thresholdConfig['min']) / this.thresholdConfig['max']) * 100);
    }
    this.thresholdPopover[0].style.left = '' + (calculatePosition) + '%';
  }

  selectDateRange(days: number, maxMinDate: object, tabSelected: boolean = false) {
    this.selectedDays = days;
    if (this.groupByParam['key'] === 'day') {
      this.calculatedDateRange = this.getDayFilterDates(maxMinDate, days);
      this.setStartEndDateHeadings(this.calculatedDateRange);
    } else if (this.groupByParam['key'] === 'week') {
      this.calculatedDateRange = this.getDateArray(maxMinDate, days);
      this.setStartEndDateHeadings(this.calculatedDateRange);
    } else if (this.groupByParam['key'] === 'month') {
      this.calculatedDateRange = this.getDateArray(maxMinDate, days);
      this.setStartEndDateHeadings(this.calculatedDateRange);
    }

    this.dateFilterObj['dates'] = this.calculatedDateRange;
    this.dateFilterObj['isApplied'] = true;
    this.dateFilterObj['selectedDaysByTabHeader'] = days;
    this.dateFilterObj['tabSelected'] = tabSelected;

    if (this.isThresholdVisible) {
      this.thresholdFilterObj['isApplied'] = true;
      this.thresholdFilterObj['hr_threshold'] = localStorage.getItem('threshold');
      this.selectedFilterObj['thresholdFilterObj'] = this.thresholdFilterObj;
    }

    if (this.isBoundTypeVisible) {
      if (this.activeBoundType === 'Terminating') {
        this.terminationFilterObj['isApplied'] = true;
        this.originationFilterObj['isApplied'] = false;
        this.terminationFilterObj['filter_type'] = 'inbound';
        this.terminationFilterObj['termination_carrier'] = this.activeCustomer;
        this.selectedFilterObj['carrierTypeIn'] = this.terminationFilterObj;
        this.selectedFilterObj['carrierTypeOut'] = this.originationFilterObj;
      } else {
        this.terminationFilterObj['isApplied'] = false;
        this.originationFilterObj['isApplied'] = true;
        this.originationFilterObj['filter_type'] = 'outbound';
        this.originationFilterObj['origination_carrier'] = this.activeCustomer;
        this.selectedFilterObj['carrierTypeOut'] = this.originationFilterObj;
        this.selectedFilterObj['carrierTypeIn'] = this.terminationFilterObj;
      }
    }
    // if (this.isOCNTypeDropdownVisible && this.activeBoundType === 'Originating') {
    if (this.activeBoundType === 'Originating') {
      this.ocnTypeFilterObj['ocnType'] = this.selectedOCNType['value'];
      this.ocnTypeFilterObj['ocnTypeValue'] = this.selectedOCNType['ocnValue'];
      this.ocnTypeFilterObj['isApplied'] = this.selectedOCNType['value'] === 'storage_ocn' ? true : false;
      this.selectedFilterObj['ocnType'] = this.ocnTypeFilterObj;
    } else {
      this.ocnTypeFilterObj['ocnType'] = this.selectedOCNType['value'];
      this.ocnTypeFilterObj['ocnTypeValue'] = this.selectedOCNType['ocnValue'];
      this.ocnTypeFilterObj['isApplied'] = false;
      this.selectedFilterObj['ocnType'] = this.ocnTypeFilterObj;
    }
    if (this.groupByParam) {
      this.selectedFilterObj['groupByFilterParam'] = this.groupByParam;
    }
    this.selectedFilterObj['dateFilterObj'] = this.dateFilterObj;

    if (this.isVerstatToggleVisible && this.selectedFilterObj['verstatToggle']) {
      this.selectedFilterObj['verstatToggle']['selection'] = this.selectedCVTView;
    }

    this.sendSelectedFilterValues();

    this.filter = 'range';
  }

  sendSelectedFilterValues(isRefreshTrigger = false) {
    this.dateFilterObj['isRefreshTrigger'] = isRefreshTrigger;
    if (this.selectedFilterObj && this.selectedFilterObj['dateFilterObj']) {
      this.dateRangeSelected.emit(this.selectedFilterObj);
      this.verstatToggleSelected.emit(this.selectedFilterObj);
      this.dateRangeToggleSelected.emit(this.calculatedDateRange);
    }
  }

  selectOCNType(event: any) {
    this.selectedOCNTypeLabel = this.selectedOCNType['ocnType'];
    this.ocnTypeFilterObj['ocnType'] = this.selectedOCNType['value'];
    this.ocnTypeFilterObj['ocnTypeValue'] = this.selectedOCNType['ocnValue'];
    this.ocnTypeFilterObj['isApplied'] = this.selectedOCNType['value'] === 'storage_ocn' ? true : false;
    this.selectedFilterObj['ocnType'] = this.ocnTypeFilterObj;

    if (!this.isDayFilterSelected) {
      this.dateFilterObj['isApplied'] = false;
      this.selectedFilterObj['dateFilterObj'] = this.dateFilterObj;
    }

    this.sendSelectedFilterValues();
  }

  getDayFilterDates(dates, days) {
    let max_date, calculatedDates = [], maxDateForCalculate, calculateDays, max: Date, min: Date;

    let month = '' + (dates[0]['date'].getMonth() + 1),
      day = '' + dates[0]['date'].getDate();

    const year = dates[0]['date'].getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }
    max_date = month + '/' + day + '/' + year;

    calculatedDates = [];
    days = days - 1;  // Days you want to subtract
    maxDateForCalculate = new Date(max_date);
    max = new Date(max_date);
    calculateDays = maxDateForCalculate.getDate() - days;
    min = new Date(maxDateForCalculate.setDate(calculateDays));
    // min= new Date(max.getTime() - (days * 24 * 60 * 60 * 1000));
    calculatedDates.push({ 'date': dates[1]['date'] > min ? dates[1]['date'] : min });
    calculatedDates.push({ 'date': max });
    return calculatedDates;
  }

  setStartEndDateHeadings(calculatedDates) {
    this.startDateHeading = calculatedDates[0].date;
    this.endDateHeading = calculatedDates[1].date;
  }

  sortDatesConfigureHeading(dates) {
    const length = dates.length;
    dates.sort(function (firstDate, secondDate) {
      if (firstDate.date < secondDate.date) {// sort dates in accending order
        return -1;
      }
      if (firstDate.date > secondDate.date) {
        return 1;
      }
      return 0; // default return value (no sorting)
    });
    this.startDateHeading = dates[0].date;
    this.endDateHeading = dates[length - 1].date;
  }

  compareDate(min, max) {
    if (Number(min) === Number(max)) {
      return true;
    }

    return false;
  }
  getTitleString() {
    this.title = this.tabName + ': ' + this.datePipe.transform(this.startDateHeading, ' MMM dd, yyyy');
    if (this.compareDate(this.startDateHeading, this.endDateHeading)) {
      return this.title + ' (UTC)';
    }
    if (this.filter === 'range' || this.isResetAll) {
      this.title += ' to' + this.datePipe.transform(this.endDateHeading, ' MMM dd, yyyy') + ' (UTC)';
    } else if (this.filter === 'multiple' && !this.isResetAll) {
      this.title += ' ... ' + this.datePipe.transform(this.endDateHeading, ' MMM dd, yyyy') +
        ' (' + this.dateRange.length + ' days)' + ' (UTC)';
    }
    return this.title;
  }

  shortenLargeNumber(num, digits) {
    return this.appService.shortenLargeNumber(num, digits);
  }

  onModalOpen() {
    this.threshold = parseInt(localStorage.getItem('threshold'));
    this.thresholdPopover[0].textContent = this.shortenLargeNumber(this.threshold, 1);
    this.setThresholdPopover(this.threshold);
  }
  onOpenPointCodesModal() {

  }
  setThreshold(threshold) {
    // Set the threshold here
    if (threshold < 10000) {
      threshold = Math.floor(threshold / 100) * 100;
    } else {
      threshold = Math.floor(threshold / 1000) * 1000;
    }
    localStorage.setItem('threshold', threshold.toString());
    $('#thresholdModal').modal('hide');
    if (!this.isDayFilterSelected) {
      this.dateFilterObj['isApplied'] = false;
      this.selectedFilterObj['dateFilterObj'] = this.dateFilterObj;
    }
    this.thresholdFilterObj['isApplied'] = true;
    this.thresholdFilterObj['hr_threshold'] = localStorage.getItem('threshold');
    this.selectedFilterObj['thresholdFilterObj'] = this.thresholdFilterObj;

    this.sendSelectedFilterValues();

  }

  setTerminationOrigination(type) {
     this.activeBoundType = type;

    if(this.onBoundTypeSelected) this.onBoundTypeSelected.emit(type);
    if (type === 'Terminating') {
      if (this.boundTypeDateConfig && this.boundTypeDateConfig['isOriginatingDate']) {
        this.maxMinDate = this.boundTypeDateConfig['maxMinDate'];
        this.dateRange = this.boundTypeDateConfig['dateRange'];
        this.siFiltersService.setDefaultMaxMinDate(this.maxMinDate);
      }

      this.isTerminationActive = true;
      this.isOriginationActive = false;

      this.terminationFilterObj['isApplied'] = true;
      this.originationFilterObj['isApplied'] = false;
      this.terminationFilterObj['filter_type'] = 'inbound';
      this.terminationFilterObj['termination_carrier'] = this.activeCustomer;
      if (this.defaultOCNType) {
        this.selectedOCNType = this.defaultOCNType;
        // this.selectedOCNTypeLabel = this.defaultOCNType['ocnType'] ? this.defaultOCNType['ocnType'] : 'TN Owner OCN';
        this.selectedOCNTypeLabel = 'OCN';
      }
      this.ocnTypeFilterObj['isApplied'] = false;
      this.ocnTypeFilterObj['ocnType'] = this.selectedOCNType['value'];
      this.ocnTypeFilterObj['ocnTypeValue'] = this.selectedOCNType['ocnValue'];
      this.selectedFilterObj['ocnType'] = this.ocnTypeFilterObj;
      this.selectedFilterObj['carrierTypeIn'] = this.terminationFilterObj;
      this.selectedFilterObj['carrierTypeOut'] = this.originationFilterObj;
    } else {
      if (this.boundTypeDateConfig && this.boundTypeDateConfig['isOriginatingDate']) {
        this.maxMinDate = this.boundTypeDateConfig['maxMinDateOriginating'];
        this.dateRange = this.boundTypeDateConfig['dateRangeOriginating'];
        this.siFiltersService.setDefaultMaxMinDate(this.maxMinDate);
      }
      this.isTerminationActive = false;
      this.isOriginationActive = true;

      this.terminationFilterObj['isApplied'] = false;
      this.originationFilterObj['isApplied'] = true;
      this.originationFilterObj['filter_type'] = 'outbound';
      this.originationFilterObj['origination_carrier'] = this.activeCustomer;
      this.ocnTypeFilterObj['isApplied'] = this.selectedOCNType['value'] === 'storage_ocn' ? true : false;
      this.ocnTypeFilterObj['ocnType'] = this.selectedOCNType['value'];
      this.ocnTypeFilterObj['ocnTypeValue'] = this.selectedOCNType['ocnValue'];
      this.selectedFilterObj['ocnType'] = this.ocnTypeFilterObj;
      this.selectedFilterObj['carrierTypeOut'] = this.originationFilterObj;
      this.selectedFilterObj['carrierTypeIn'] = this.terminationFilterObj;
      if(this.selectedFilterObj['verstatToggle']) delete this.selectedFilterObj['verstatToggle'];
      this.selectedCVTView = "Robocall";
    }

    if (this.groupByParam['key'] === 'day') {
      this.calculatedDateRange = this.getDayFilterDates(this.maxMinDate, this.selectedDays);
      this.setStartEndDateHeadings(this.calculatedDateRange);
    } else if (this.groupByParam['key'] === 'week') {
      this.calculatedDateRange = this.getDateArray(this.maxMinDate, this.selectedDays);
      this.setStartEndDateHeadings(this.calculatedDateRange);
    } else if (this.groupByParam['key'] === 'month') {
      this.calculatedDateRange = this.getDateArray(this.maxMinDate, this.selectedDays);
      this.setStartEndDateHeadings(this.calculatedDateRange);
    }
    this.dateFilterObj['dates'] = this.calculatedDateRange;
    this.selectedFilterObj['dateFilterObj'] = this.dateFilterObj;

    if (!this.isDayFilterSelected) {
      this.dateFilterObj['isApplied'] = false;
      this.selectedFilterObj['dateFilterObj'] = this.dateFilterObj;
    }

    this.sendSelectedFilterValues();
  }

  getActiveCustomerAndFormat() {
    const activeCustomer = this.siAuthenticationService.activeCustomer.getValue();

    return activeCustomer.replace(/^\w/, c => c.toUpperCase()); // First letter capital
  }

  selectgroupByParam(selectedObj, maxMinDate, days) {
    this.groupByParam = selectedObj[0];
    this.dayFilterValues = selectedObj[0]['value'];
    this.selectDateRange(days, maxMinDate);
  }

  setDescriptiontitle(): string {
    let title: string = '';
    if (this.selectedTabName === 'Provider Insights' && this.description['isNotContainThreshold']) {
      return this.isTerminationActive ?  title = this.description['descriptionFirst'] + 'terminating at the carrier. ': this.description['descriptionFirst'] + 'originating from the carrier. ';
    }
    else if (this.description['isNotContainThreshold']) {
      return title = this.description['descriptionFirst'];
    }

    if(this.selectedTabName === 'Provider Insights'){
      if (this.isThresholdVisible) {
        const threshold = this.thresholdFilterObj['hr_threshold'] ? ' ' + d3.format(',')(this.thresholdFilterObj['hr_threshold']) + ' ' : '';
        this.isTerminationActive? title = this.description['descriptionFirst'] + 'terminating at the carrier. ' + threshold +
          this.description['descriptionSecond'] + this.selectedOCNTypeLabel + '. ' : title = this.description['descriptionFirst'] + 'originating at the carrier. ' + threshold +
          this.description['descriptionSecond'] + this.selectedOCNTypeLabel + '. '
      } else {
        this.isTerminationActive ? title = this.description['descriptionFirst'] + 'terminating at the carrier. ' + this.description['descriptionSecond'] :
          this.description['descriptionFirst'] + 'originating at the carrier. ' + this.description['descriptionSecond']
      }
    } else {
      if (this.isThresholdVisible) {
        const threshold = this.thresholdFilterObj['hr_threshold'] ? ' ' + d3.format(',')(this.thresholdFilterObj['hr_threshold']) + ' ' : '';
        title = this.description['descriptionFirst'] + threshold +
          this.description['descriptionSecond'] + this.selectedOCNTypeLabel + '. '; // + this.description['descriptionThird'];
      } else {
        title = this.description['descriptionFirst'] + this.description['descriptionSecond'];
      }
    }

    return title;
  }

  getDescriptionVolumeTitle(): string {
    return this.description['descriptionThird'] + this.description['descriptionFourth'];
  }

  getDateArray(minMaxDates, number) {
    let dateArray: Array<object>; let startDate;
    const endDate = SiDataViz.helper.cloneObject((minMaxDates[0]), {});
    // let dataMinDate = SiDataViz.helper.cloneObject((minMaxDates[1]), {});
    if (this.groupByParam['key'] === 'month') {
      startDate = new Date(endDate['date'].setMonth(endDate['date'].getMonth() - (number - 1)));
      // if(startDate.getTime() < dataMinDate['date'].getTime()){
      // startDate = dataMinDate['date'];
      // }else{
      startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
      // }
    } else if (this.groupByParam['key'] === 'week') {
      startDate = new Date((this.getMonday(endDate['date'])).setDate((this.getMonday(endDate['date'])).getDate() - ((number - 1) * 7)));
    }
    dateArray = [{ 'date': startDate }, { 'date': minMaxDates[0]['date'] }];
    return dateArray;
  }
  getMonday(d) {
    const day = d.getDay(),
      diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  /**
     * Showing Timer
     * @param counter Seconds to run timer
     */
  startTimer(counter) {
    clearInterval(this.timerInterval);
    this.timerInterval = setInterval(() => {
      counter--;
      if (counter <= 0) {
        clearInterval(this.timerInterval);
      }
      let minutes: any = Math.floor(counter / 60);
      let seconds: any = counter % 60;
      minutes = (minutes === -1) ? 0 : minutes;
      seconds = (seconds === -1) ? 0 : seconds;
      minutes = (minutes < 10) ? '0' + minutes : minutes;
      seconds = (seconds < 10) ? '0' + seconds : seconds;
      this.display = minutes + ':' + seconds + ' Min ';
    }, 1000);
  }

   /**
   * Determines last page refresh information
   * @param updated timezone & abbreviation
   */
     setLastDataRefresh(res, m) {
        if (this.isTimerVisible) {
          try {
            // clearTimeout(this.timerInterval); //interval to clear multiple calls
            clearInterval(this.timerInterval);
            clearTimeout(this.timeOut);

            // Parse the response date
            if (!res) {
              console.warn('No update_time provided to setLastDataRefresh');
              this.refreshDate = this.getLocalTimeWithTimezone(new Date());
              return;
            }

            // Parse UTC timestamp and convert to local timezone
            this.lastDataRefresh = new Date(res.replace(/-/g, '/') + ' UTC');
            this.localTime = new Date();

            // Check for last dashboard refresh.
            const lastDashboardRefresh = new Date(localStorage.getItem('lastDashboardRefresh'));
            if (lastDashboardRefresh < this.lastDataRefresh) {
              // Refresh immidiatly
              this.sendSelectedFilterValues();
              localStorage.setItem('lastDashboardRefresh', this.localTime);
            }

            // Run the timer
            const diffSec = 60 - this.localTime.getUTCSeconds();
            let diffMins = ((60 - (this.localTime.getUTCMinutes())) + 30) % 60;
            diffMins = (diffMins <= 0) ? 59 : (diffMins + (diffSec === 60 ? 0 : -1));

            // Ensure m is properly initialized
            if (!m) {
              m = {
                updatedTimeZone: null,
                abbr: null,
                auto_refresh: false
              };
            }

            // Get timezone abbreviation from browser's local timezone
            const tzAbbr = this.getTimezoneAbbreviation();

            // Display time in user's local timezone (browser default)
            this.refreshDate = this.lastDataRefresh.toLocaleString('en-US') + ' ' + tzAbbr;

            console.log('Last page refresh set to:', this.refreshDate);

            this.isRefreshTime = false;
            if (m.auto_refresh) {
              clearTimeout(this.timeOut);
              this.startTimer((diffMins * 60) + diffSec);
              this.timeOut = setTimeout(() => {
                this.onRefresh();
              }, ((diffMins * 60) + diffSec) * 1000);
            } else {
              clearInterval(this.timerInterval);
              clearTimeout(this.timeOut);
              this.display = '';
            }
          } catch (error) {
            console.error('Error in setLastDataRefresh:', error);
            this.refreshDate = this.getLocalTimeWithTimezone(new Date());
          }
        }

      }

   /**
    * Get timezone abbreviation from browser's local timezone
    */
   private getTimezoneAbbreviation(): string {
     try {
       // Get the timezone name using Intl API
       const formatter = new Intl.DateTimeFormat('en-US', {
         timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
         timeZoneName: 'short'
       });
       const parts = formatter.formatToParts(new Date());
       const tzPart = parts.find(part => part.type === 'timeZoneName');
       if (tzPart && tzPart.value) {
         return tzPart.value;
       }

       // Fallback: extract from toLocaleString
       const timeString = new Date().toLocaleString('en-US', { timeZoneName: 'short' });
       const matches = timeString.match(/\b([A-Z]{2,4})\b/);
       return matches ? matches[1] : 'UTC';
     } catch (error) {
       console.warn('Error getting timezone abbreviation:', error);
       return 'UTC';
     }
   }

   /**
    * Format date with local timezone abbreviation
    */
   private getLocalTimeWithTimezone(date: Date): string {
     try {
       const tzAbbr = this.getTimezoneAbbreviation();
       return date.toLocaleString('en-US') + ' ' + tzAbbr;
     } catch (error) {
       return date.toLocaleString('en-US');
     }
   }

  /**
   * refresh data
   * @param event
   */
  onRefresh(refreshDate: any = false) {
    if (this.isTimerVisible) {
      if (refreshDate && this.isAutoRefreshDisabled) {
        return;
      } else {
        if (!this.isAutoRefreshDisabled) {
          this.sendSelectedFilterValues(true);
          localStorage.setItem('lastDashboardRefresh', this.localTime);
        }
        this.isRefreshTime = true;
        this.getRefreshTime();
      }
    }
  }

    getRefreshTime() {
      if (this.isTimerVisible) {
        this.isRefreshTime = false;
        this.appService.getDateList(this.tabName).subscribe(
          (response) => {
            // Handle response safely
            if (response && response.length > 0 && response[0]) {
              const res = response[0]['update_time'];
              if (res) {
                this.rawRefreshTimeResponse = res;
                // Ensure preObj is initialized before calling setLastDataRefresh
                if (!this.preObj) {
                  this.preObj = {
                    updatedTimeZone: null,
                    abbr: null,
                    auto_refresh: false
                  };
                }
                this.setLastDataRefresh(res, this.preObj);
              } else {
                console.warn('update_time not found in response', response[0]);
                // Set a default refresh date if update_time is missing
                this.refreshDate = this.getLocalTimeWithTimezone(new Date());
              }
            } else {
              console.warn('Invalid response structure', response);
              // Set a default refresh date if response is invalid
              this.refreshDate = this.getLocalTimeWithTimezone(new Date());
            }
          }, (error) => {
            console.error('Error fetching refresh time:', error);
            // Set a default refresh date on error
            this.refreshDate = this.getLocalTimeWithTimezone(new Date());
          });
      }
    }

  setColumnWidth() {
    if (this.tabName === 'Robocall Scoring' || this.tabName === 'Score and Verstat' || this.tabName === 'Score and STIR/SHAKEN') {
      if (this.isVerstatToggleVisible) {
        if (this.isFilterExpanded) {
          this.firstColumnWidth = 'col-lg-5 col-md-5';
          this.secondColumnWidth = 'col-lg-7 col-md-7';
        } else {
          this.firstColumnWidth = 'col-lg-5 col-md-5';
          this.secondColumnWidth = 'col-lg-7 col-md-7';
        }
      } else {
        if (this.isFilterExpanded) {
          this.firstColumnWidth = 'col-lg-5 col-md-5';
          this.secondColumnWidth = 'col-lg-7 col-md-7';
        } else {
          this.firstColumnWidth = 'col-lg-5 col-md-5';
          this.secondColumnWidth = 'col-lg-7 col-md-7';
        }
      }

    } else {
      if (this.isFilterExpanded) {
        this.firstColumnWidth = 'col-lg-7 col-md-7';
        this.secondColumnWidth = 'col-lg-5 col-md-5';
      } else {
        this.firstColumnWidth = 'col-lg-6 col-md-6';
        this.secondColumnWidth = 'col-lg-6 col-md-6';
      }
    }
  }

  verstatToggle(event) {
    const filterObj = {
      isApplied: true,
      selection: this.selectedCVTView
    };
    this.selectedFilterObj['verstatToggle'] = filterObj;
    this.sendSelectedFilterValues();
  }

  ngOnDestroy() {
    clearInterval(this.timerInterval);
    clearTimeout(this.timeOut);
  }
}
